import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-autosuggest',
  templateUrl: './autosuggest.component.html',
  styleUrls: ['./autosuggest.component.css']
})
export class AutosuggestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
